import { DriveListState, FetchStatus, getDriveItemStatusFromMap, DriveItemFetchState } from '../../../containers/DriveItemList/reducer';
import { Api } from '../../../typings/api';
import UserAgentUtils from '../../../utils/userAgent';

export const getDriveItemIds = (
	resources: Api.DriveItemResource[],
	{ driveItems, driveItemsFetchStatus }: DriveListState,
	isValidResource: (item: Api.DriveItem) => boolean,
	extraDriveIds?: number[],
	extraFilterFn?: (item: Api.DriveItem) => boolean,
): number[] => {
	const filteredDriveItemIds = resources
		.filter((item) => {
			const driveItemFetchStatus = getDriveItemStatusFromMap(driveItemsFetchStatus, item.id);
			const { metaFetchStatus } = driveItemFetchStatus;
			const driveItem = {
				...item,
				name: driveItems[item.id]
					? driveItems[item.id].name
					: undefined,
				componentType: driveItems[item.id]
					? driveItems[item.id].componentType
					: undefined,
				format: driveItems[item.id]
					? driveItems[item.id].format
					: undefined,
			};

			return (driveItem.type === Api.DriveItemType.Directory || isValidResource(driveItem as Api.DriveItem))
				&& metaFetchStatus !== FetchStatus.ERROR
				&& (extraFilterFn ? extraFilterFn(driveItem as Api.DriveItem) : true);
		})
		.map(({ id }) => id);

	return extraDriveIds
		? [...new Set([...extraDriveIds, ...filteredDriveItemIds])] // skip duplication of extra drive items (sharedDir, sourcesDir)
		: filteredDriveItemIds;
};

export const isFetchingState = (
	driveFolderId: number | undefined,
	driveItemsFetchStatus: { [k: number]: DriveItemFetchState },
): boolean => {
	if (driveFolderId && !UserAgentUtils.isMobileApp) {
		const driveFolderFetchStatus = getDriveItemStatusFromMap(driveItemsFetchStatus, driveFolderId);
		const { contentBlocksStatus, metaFetchStatus } = driveFolderFetchStatus;

		if (metaFetchStatus !== FetchStatus.FETCHED && metaFetchStatus !== FetchStatus.ERROR) {
			return true;
		}

		const blocks = Object.keys(contentBlocksStatus);
		for (let i = 0; i < blocks.length; i++) {
			const block = blocks[i];
			const blockStatus: FetchStatus = contentBlocksStatus[block];

			if (blockStatus === FetchStatus.FETCHING) {
				return true;
			}
		}
	}

	return false;
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/ResourceSelector/DrivePicker/utils.ts